import React from 'react'

import PageSection, { Props as PageSectionProps } from '../../components/layout/PageSection'

interface Props extends PageSectionProps {
  hideWhenEmpty?: boolean
  queryFn: () => { data: Array<unknown> | null | undefined, isLoading: boolean, error: Error | null }
}

const PageSectionContainer: React.FC<Props> = ({ queryFn, hideWhenEmpty, children, ...rest  }) => {
  const { data } = queryFn()

  if(data && data.length === 0 && hideWhenEmpty) { return null }

  return (
    <PageSection {...rest}>
      {children}
    </PageSection>
  )
}

export default PageSectionContainer
